const styles = {
  stepsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  stepsWrapperStep2: {
    paddingRight: '24px',
  },
  step: {
    width: 10,
    height: 10,
    borderRadius: 10,
    backgroundColor: '#E4E4EA',
    marginLeft: 6,
    marginRight: 6,
  },
  active: {
    backgroundColor: '#1D2943',
    width: 20,
  },
}

export { styles }
